// Tamanho do lote da grade no modo por consulta (29/10/2026). O editor grava o
// valor como texto, e um "0" passava pela checagem de vazio: total / "0" dava
// infinito, a paginação quebrava e a página inteira caía com erro 500. Lote
// zero, vazio ou inválido vale o padrão.
export const LOTE_PADRAO = 25;

// Números da barra lateral (limite, pular, lote) chegam do editor como texto
// (29/10/2026): "5" + 1 + 1 virava "511" e a capa buscava todas as notícias.
// Vazio, inválido ou abaixo do mínimo vale o padrão.
export const inteiro = (valor, padrao, minimo = 1) => {
  const n = Math.floor(Number(valor));
  return Number.isFinite(n) && n >= minimo ? n : padrao;
};

export const loteDaConsulta = (valor) => inteiro(valor, LOTE_PADRAO);
